import { gql } from '@apollo/client';

export const SEARCH = gql`
  query Search($term: String!) {
    search(term: $term) {
      ... on Asset {
        id
        vin
        lastSix
        stockNumber
        clientNumber
        name
        seller { id, name }
      }
      ... on Buyer {
        id
        name
        fullDisplayName
      }
      ... on Sale {
        id
        name
      }
      ... on SaleAsset {
        id
        lotNumber
        asset {
          id
          vin
          lastSix
          stockNumber
          name
          seller { id, name }
        }
        sale { saleOn }
      }
      ... on Seller {
        id
        name
      }
      ... on Vendor {
        id
        name
      }
      ... on PaddleNumberBuyer {
        id
        paddleNumber
        buyer {
          id
          name
          fullDisplayName
        }
      }
    }
  }
`;
